import { useCallback } from 'react';

import { useNavigate } from '@cast/infrastructure-organization';
import { useWoopInstallationStatus } from 'features/workload-optimization/hooks/useWoopInstallationStatus';

import {
  buildClusterAutoscalerPath,
  buildClusterWoopPath,
} from '@oneclick/constants/navigation';
import { usePoliciesV2Query } from '@cast/shared-cluster-autoscaler-data-access';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useOptimizeClusterNavigation = () => {
  const navigate = useNavigate();
  const { cluster } = useCluster();
  const { data: policies, isLoading: isPoliciesLoading } = usePoliciesV2Query({
    params: { clusterId: cluster.id },
  });
  const { isInstalled: isWoopInstalled } = useWoopInstallationStatus();

  const isNavigationReady = !isPoliciesLoading && policies !== undefined;

  const navigateToOptimize = useCallback(() => {
    if (!isNavigationReady) {
      return;
    }

    if (!policies.enabled) {
      navigate(buildClusterAutoscalerPath(cluster.id));
      return;
    }

    if (!isWoopInstalled) {
      navigate(buildClusterWoopPath(cluster.id));
    }
  }, [
    cluster.id,
    isNavigationReady,
    isWoopInstalled,
    navigate,
    policies?.enabled,
  ]);

  return { navigateToOptimize, isNavigationReady };
};
